import { connect } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import Main from 'src/components/riders/rider-portal/Main'
import { IStoreState } from 'src/types'

export function mapStateToProps(state: IStoreState, ownProps: Record<string, unknown>): Record<string, unknown> {
  return {}
}

export function mapDispatchToProps(dispatch: ThunkDispatch<IStoreState, unknown, AnyAction>): Record<string, unknown> {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main)



// WEBPACK FOOTER //
// ./src/containers/riders/rider-portal/Main.ts